import { useSelector } from 'react-redux'
import {
  selectAllBillToLocations,
  selectAllServiceLocations,
} from '@user/store/entityLocations'
import { useValidateLocations } from './useValidateLocations'
import { selectCurrentUser } from '@user/store/authorization'
import { externalProductPestPacName } from '@sales-center/common'
import { useMemo } from 'react'
import { locationToFormModel } from '@user/components/Agreements/CreateAgreementDrawer/CreateAgreementForm/TemplateDetails/CreateLocationForm/hooks/useHandlers'

export function useTabData() {
  const billToLocations = useSelector(selectAllBillToLocations)
  const serviceLocations = useSelector(selectAllServiceLocations)
  const { externalProduct } = useSelector(selectCurrentUser)

  const { validatedBillToLocations, validatedServiceLocations, anyInvalid } =
    useValidateLocations({
      billToLocations,
      serviceLocations,
      runPestPacValidation: externalProduct === externalProductPestPacName,
    })

  const invalidLocations = useMemo(
    () => [
      ...validatedBillToLocations.map((x) => locationToFormModel(x)),
      ...validatedServiceLocations
        .map((x) => locationToFormModel(x))
        .sort((x) => x.id),
    ],
    [billToLocations, serviceLocations],
  )

  return {
    anyInvalid,
    billToLocations: validatedBillToLocations,
    serviceLocations: validatedServiceLocations,
    invalidLocations,
  }
}
